export default function CalculationExplanation() {
  return (
    <div className="text-md">
      <div id="top-border"></div>
      <div id="main">
        <h1 className="mb-8 text-xl">CDL ROI Calculator - Explanations</h1>
        <table
          className="w-full max-w-480 table-auto bg-gray-50 [&_td]:p-4 [&_tr]:border-b"
          id="assumptions"
        >
          <thead className="font-semibold">
            <tr>
              <td>Description</td>
              <td>Explanation</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Annual process efficiency savings</td>
              <td>
                Calculated as the number of procurements ran multiplied by the
                process efficiency saving per tender, taken from the Home Office
                / OGCbs (now CCS) eSourcing Benefits Study.
              </td>
            </tr>
            <tr>
              <td>Annual direct cost reductions</td>
              <td>
                Calculated as the number of procurements ran multiplied by the
                direct cost reduction per tender, taken from the Home Office /
                OGCbs (now CCS) eSourcing Benefits Study.
              </td>
            </tr>
            <tr>
              <td>Annual reductions for external consultancy</td>
              <td>
                Calculated as the Project team size x (weighted cost of internal
                staff + weighted cost of external consultants) x length of
                evaluation x % time saved
              </td>
            </tr>
            <tr>
              <td>Annual reductions in contract changes</td>
              <td>
                Calculated as the Average contract value x average cost of
                changes x avoided changes x number of procurements
              </td>
            </tr>

            <tr>
              <td>
                Average cost of contract changes as a percentage of overall
                budget
              </td>
              <td>
                Most contract changes and &quot;scope creep&quot; derive from a
                lack of clarity at the requirements/evaluation model definition
                stage and less than perfect measurement of bids against the
                defined model. By running a &quot;tighter&quot; evaluation, a
                project has a greater chance of highlighting and dealing with
                potential issues before the contract is agreed. The history of
                major UK Government procurements is dotted with examples of
                escalating costs and expensive contract changes.It is contended
                that on average a 3% cost of total budget is generated by
                contract changes and scope creep.
              </td>
            </tr>
            <tr>
              <td>
                Percentage of contract changes avoided through the use of AWARD
              </td>
              <td>
                Of the 3% increase in costs, a 2% reduction could be achieved
                through the use of eEvaluation technology. This equates to 0.06%
                of total budget being saved by using a radically improved
                evaluation process. This amounts to a conservative assumption.
                The OGC Successful Delivery Toolkit states on evaluation;
                &quot;...the evaluation strategy therefore shapes the whole
                project; it sets the direction of procurement and the subsequent
                contract.&quot;
              </td>
            </tr>
            <tr>
              <td>Reduced risk of choosing the wrong supplier</td>
              <td>
                Value of savings based upon the average difference between bids
                and the reduction in risk resulting from the use of AWARD
                eEvaluation.
              </td>
            </tr>
            <tr>
              <td>Average difference between bids</td>
              <td>
                If the difference in VfM between any two bids/tenders were
                significantly less than 5%, there would be a VfM argument for
                abandoning the selection process in favour of some kind of
                rota/random distribution of contracts (owing to the cost of the
                selection process itself). Private sector due-diligence and
                selection processes might also be deemed unnecessary. Evidently,
                this is not the case and there is far more than a 5% VfM
                differential being offered by suppliers. 5% is therefore a
                conservative estimate.
              </td>
            </tr>
            <tr>
              <td>Risk of choosing wrong supplier without AWARD</td>
              <td>
                Although generally functional, traditional MS Office software
                tools do not always provide the best environment for making
                complex, multi-criteria, multi-stakeholder decisions. By their
                nature, the construction of complex spreadsheets can be prone to
                human error. Email distribution of documents, instructions, and
                clarification management tasks is less than ideal since email
                systems are liable to failure, loss or mal-administration. A
                lack of complete information to key decision makers could
                represent a serious problem and relates to a small, but not
                insignificant amount of non-optimum procurement decisions. The
                4% probability figure is a conservative estimate. It would be
                unusual for there ever to be any doubt concerning any public
                sector procurement decision, if it really were this low.
              </td>
            </tr>
            <tr>
              <td>Risk of choosing wrong supplier with AWARD</td>
              <td>
                The collaborative, homogenous nature of AWARD eEvaluation
                largely reduces the risk of error and levels of uninformed
                decision making. It represents a significantly lower risk than
                using manual processes. The testing, accreditation and thorough
                evaluation of the software by OGC/OGCbs, alongside many in the
                field examples (including at the Home Office), verify the
                integrity of the AWARD eEvaluation evaluation tool.
              </td>
            </tr>
            <tr>
              <td>Potential reductions in delays caused by challenges</td>
              <td>
                Value of savings of sourcing costs resulting from the decrease
                in potential additional costs arising from a challenge.
              </td>
            </tr>
            <tr>
              <td>Potential delay caused by a challenge (in months)</td>
              <td>
                Any formal challenge to a public sector procurement outcome by
                an unsuccessful bidder can cause significant delays. In many
                cases, the challenge has to be addressed to the bidders
                satisfaction before the contract can commence and the project
                continue. Dealing with the challenge and related (or unrelated)
                ROI enquiries can take up large amounts of time and effort.
              </td>
            </tr>
            <tr>
              <td>Probability of challenge without AWARD</td>
              <td>
                The probability of a challenge is real. This probability is
                rising as the regulatory and legal environment increasingly
                provides bidders with more tools to successfully challenge a
                contract AWARD eEvaluation decision.{" "}
              </td>
            </tr>
            <tr>
              <td>Probability of challenge with AWARD</td>
              <td>
                Whilst AWARD eEvaluation does not eliminate all risk of a
                successful challenge, it does significantly reduce it.
              </td>
            </tr>
            <tr>
              <td>Potential deductions on paying out successful claims</td>
              <td>
                Value of savings based upon the precedent value of 15% of the
                contract value and the reduction in the risk of a challenge
                resulting from the use of AWARD eEvaluation.
              </td>
            </tr>
            <tr>
              <td>
                Percentage procurement budget awarded to losing bidder following
                successful claims
              </td>
              <td>
                (Harmon vs The House of Commons, November 1999). Precedent set
                for 15% of the value of potential contract for loss of profit
                and abortive tendering costs.
              </td>
            </tr>
            <tr>
              <td>Probability of successful challenge without AWARD </td>
              <td>
                Although successful challenge of a procurement decision is rare,
                it does occur and has significant implications. The legislative
                landscape and business culture are both moving toward a position
                where challenge is becoming more likely than it has been in the
                past. A 1 % overall risk is a reasonable assumption.
              </td>
            </tr>
            <tr>
              <td>Probability of successful challenge with AWARD </td>
              <td>
                Whilst AWARD eEvaluation does not eliminate all risk of a
                successful challenge, it does significantly reduce it.
              </td>
            </tr>
            <tr>
              <td>Average number of pages per tender</td>
              <td>
                Based upon the statistical analysis of tender documentation as
                illustrated in section 6.2.2 of the Home Office / OGCbs
                eSourcing Benefits Study.
              </td>
            </tr>
            <tr>
              <td>Average reduction in printed paper (A4)</td>
              <td>
                Average number of pages per tender x number of procurements
              </td>
            </tr>
            <tr>
              <td>Estimated number of trees saved</td>
              <td>
                Average reduction in printed paper converted into estimated
                number of trees using a factor from www.conservatree.com
              </td>
            </tr>
            <tr>
              <td>Estimated cost saved on petrol</td>
              <td>
                Calculated using average commute, as per 2011 UK Census, and
                average price of petrol from 2015. Increased to take into
                account external consultants traveling further/hotel
                costs/flights/delays/etc
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
